import React from 'react'

const AboutPage = () => {
  return (
    <div name="about" className="w-full h-auto bg-gradient-to-b from-gray-800 to-black">
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pd-8"> 
          <p className="text-4xl font-bold inline border-b-4 border-gray-500 text-white">About</p>
        </div>

          <p className="text-xl mt-10 text-white text-justify">
          I'm a dedicated robotics enthusiast with a deep interest in AGV's and Drones. 
I recently completed my MS in Robotics from Northeastern University, where I specialized in 
Control Systems, Motion Planning, Perception, and AI—key components in the development of intelligent, autonomous systems.
          </p>
          <p className="text-xl mt-10 text-white text-justify">
          My passion for robotics drove my contributions to cutting-edge research at the Silicon Synapse Lab under Prof. Alireza Ramezani, where I worked on multimodal robots, 2.5D elevation mapping, and advanced motion planning. Currently, as a Robotics & AI Engineering Co-op at Piaggio Fast Forward, I focus on developing advanced semantic mapping and voice-based navigation systems. This includes integrating Mask R-CNN for object recognition, using depth data from RealSense cameras, and tracking objects with Kalman filters. I also develop systems that enhance real-time navigation using NLP and CLIP, allowing robots to respond efficiently to natural language commands. 
          </p>
          <p className="text-xl mt-10 text-white text-justify">
          With hands-on experience in designing custom robotic systems and contributing to various robotics projects, 
I'm eager to collaborate with others who share my passion for robotics. Feel free to connect!
          </p>
          

      </div>
    </div>
  )
}

export default AboutPage